import { FC } from 'react';

import { BannerLogo, ViewMore } from '@/UI';
import { CompanyInfoProps } from './types';
import { SocialIcons } from '@/UI/Molecules/SocialIcons';
import ReviewsInfo from './ReviewsInfo';
import * as St from './CompanyInfo.styles';

export const CompanyInfo: FC<CompanyInfoProps> = ({
  logo,
  banner,
  collapsed,
  rrss,
  companyDescription = '',
  locationDescription = '',
  isLoading,
}) => (
  <St.CompanyInfoContainer collapsed={collapsed} hasBanner>
    <St.HeroWrapper>
      <BannerLogo banner={banner} logo={logo} />
      {rrss && rrss.length > 0 && (
        <St.SocialIconsWrapper collapsed={collapsed} hasBanner>
          <SocialIcons rrss={rrss} className="socialIcons" isLoading={isLoading} />
        </St.SocialIconsWrapper>
      )}
    </St.HeroWrapper>
    {!collapsed && (
      <ViewMore
        textContent={companyDescription}
        textContentSecondary={locationDescription}
        showIcon
        maxNumOfLines={8}
        arial-label="companyDescription"
        className="companyDescription"
        data-testid="companyDescription"
        isLoading={isLoading}
      />
    )}
    <ReviewsInfo />
  </St.CompanyInfoContainer>
);
